import React from 'react';
import styles from './MobileGridLoadingIndicator.module.css';

/**
 * Mobile-specific loading indicator for the explore grid
 * Displays a skeleton UI while content is loading
 */
const MobileGridLoadingIndicator: React.FC = () => {
  // Create placeholder items to maintain grid layout
  // Using 4 items for mobile (2x2 grid) to match the typical mobile view
  const placeholders = Array(4).fill(null);
  
  return (
    <div className={styles.mobileGridLoadingContainer}>
      {placeholders.map((_, index) => (
        <div key={index} className={styles.placeholderItem}>
          <div className={styles.placeholderImage}>
            <div className={styles.shimmerOverlay}></div>
          </div>
          <div className={styles.placeholderContent}>
            <div className={styles.placeholderTitle}>
              <div className={styles.shimmerOverlay}></div>
            </div>
            <div className={styles.placeholderText}>
              <div className={styles.shimmerOverlay}></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MobileGridLoadingIndicator; 